import { AxiosError, AxiosPromise, AxiosResponse } from 'axios'
import { Delete } from './Delete'
import { Filter } from './Devices'
import { Get } from './Get'
import { UserProfileObject } from './organization.types'
import { Post } from './Post'
import { Put } from './Put'
import { ApiHelpers, APIHosts } from './ApiHelpers'

export interface RolesResponse {
  id: string
  name: string
  normalizedName: string
  concurrencyStamp: string
  roleName: string
  newRolename: string
}

// Matches `Base.Models.RoleType` — `RoleController.GetAll` defaults to `User`
// when `type` is omitted, so pass `ServicePrincipal` explicitly to browse those.
export type RoleType = 'User' | 'ServicePrincipal'

export interface IRoleProductClaim {
  productClaimId: string
  claimType: string
  claimValue: string
}

export interface RoleClaimsResponse {
  roleId: string
  claims: IRoleProductClaim[]
}

class RolesServiceController extends ApiHelpers {
  ApiHost = APIHosts.LicenseManager;

  public Put = {
    // Route is PUT /roles/{roleName} — previously posted to bare
    // `${baseUrl}/roles` (no roleName segment), which would 404.
    updateRolesInfo: (data: { roleName: string; newRolename: string }) => {
      const baseUrl = this.getHost(this.ApiHost);
      return Put(`${baseUrl}/roles/${encodeURIComponent(data.roleName)}`, data);
    },
    replaceRoleClaims: (roleId: string, productClaimIds: string[]) => {
      const baseUrl = this.getHost(this.ApiHost);
      return Put(`${baseUrl}/roles/${roleId}/claims`, { productClaimIds });
    },
  }

  public Get = {
    getAllRoles: (type?: RoleType) => {
      const baseUrl = this.getHost(this.ApiHost);
      const url = `${baseUrl}/roles`;
      return Get(url, type ? { params: { type } } : {});
    },
    getRoleClaims: (roleId: string) => {
      const baseUrl = this.getHost(this.ApiHost);
      return Get(`${baseUrl}/roles/${roleId}/claims`);
    },
  }

  public Post = {
    addRoles: (rolesName: string, type?: RoleType) => {
      const baseUrl = this.getHost(this.ApiHost);
      const url = `${baseUrl}/roles/${encodeURIComponent(rolesName)}`;
      return Post(url, {}, type ? { params: { type } } : {});
    },
  }

  public Delete = {
    removeRoles: (rolesName: string) => {
      const baseUrl = this.getHost(this.ApiHost);
      const url = `${baseUrl}/roles/${encodeURIComponent(rolesName)}`;
      return Delete(url);
    },
  }
}

export const RolesService = new RolesServiceController()
